import React from 'react';
import './OverlayHogar.css';

const OverlayHogar = ({ onContinue, planosUrl }) => {
  return (
    <div className="overlay-hogar">
      <div className="overlay-hogar-content">
        <img
          src={process.env.PUBLIC_URL + '/Logo/logo-nuevo-Garden-1 2.png'}
          alt="Logo Garden"
          className="overlay-hogar-logo"
        />
        <h1 className="overlay-hogar-title">Aquí está tu nuevo hogar.</h1>
        <p className="overlay-hogar-desc">
          Cada línea, cada espacio, pensado para acompañarte en tus mejores etapas.
        </p>
        <div className="overlay-hogar-btns">
          <button className="overlay-hogar-btn overlay-hogar-btn-main" onClick={onContinue}>
            Continuar
          </button>
          <a
            className="overlay-hogar-btn overlay-hogar-btn-link"
            href={planosUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            Vista aérea
          </a>
        </div>
      </div>
    </div>
  );
};

export default OverlayHogar; 